import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.get('/refresh', {
            withCredentials: true
        });
        setAuth(prev => ({
            ...prev,
            user: response.data.user ?? prev.user,
            roles: response.data.roles,
            accessToken: response.data.accessToken,
            plan: response.data.plan ?? prev.plan,
            subscriptionStatus: response.data.subscriptionStatus ?? prev.subscriptionStatus,
            limits: response.data.limits ?? prev.limits,
        }));
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;
